// extracted by mini-css-extract-plugin
module.exports = {"dot":"styles-module--dot--1g_Rd"};